export default "__VITE_ASSET__CLBMs_LG__"